'use client'

import Card, {
  CardProps,
  SupplierCardType,
} from '@/components/v3/atoms/card/card'
import { useDwellInView } from '@/hooks/use-dwell-in-view'
import { getCardHref } from '@/utils/getCardHref'
import { categoryImpressionGTMEvent } from '@/utils/gtmEvents/categoryImpressionGTMEvent'
import { useEffect, useRef } from 'react'

type TrackedCardProps = Omit<CardProps, 'type'> & { type: SupplierCardType }

export const TrackedCard = (props: TrackedCardProps) => {
  const ref = useRef<HTMLDivElement>(null)
  const hasDwelled = useDwellInView(ref, { threshold: 0.5, dwellMs: 1000 })
  const firedRef = useRef(false)

  useEffect(() => {
    if (!hasDwelled || firedRef.current) return
    firedRef.current = true

    categoryImpressionGTMEvent(
      props.itemId,
      getCardHref(props.type, props.path),
      props.type
    )
  }, [hasDwelled, props.itemId, props.path, props.type])

  return <Card {...props} ref={ref} />
}
